<template>
  <div class="nav">
    <div class="nav-left">
      <div class="flex-col-center">
        <div class="nav-title">部门导航</div>
        <!-- <p class="nav-more" @click="deptMore">查看更多></p> -->
      </div>
      <section class="nav-wrap">
        <div class="item" v-for="item in deptDataList" @click="toUrl(item.WID)">
          <img src="../../static/assets/icon.png" alt />
          <p>{{ item.NAME }}</p>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import * as utils from "../utils";
import api from "../api";
export default {
  data() {
    return {
      deptDataList: [],
      schoolDataList: [],
    };
  },
  methods: {
    deptMore() {
      window.open(window.deptMore);
    },

    schoolMore() {
      window.open(window.schoolMore);
    },

    toUrl(id) {
      window.open(location.origin + "/oa/sys/newoadxzxx/wbxzxxList.do?boxCode=" + id + "&optCode=1#/wbxzxx")
    },

    getDepartment() {
      utils.Get(api.getDepartment).then(res => {
        let resp = JSON.parse(res.data);
        this.deptDataList = resp.datas;
      })
    },
  },
  created() {
    this.getDepartment();
  },
};
</script>
<style scoped>
.nav {
  width: 100%;
  display: flex;
  /* align-items: center; */
  justify-content: space-between;
  margin-top: 1.25rem;
}

.nav-wrap {
  /* width: 100%; */
  height: 21.5rem;
  overflow: auto;
  padding: 0 1.5rem;
}

.nav-left,
.nav-right {
  /* width: 14.13rem; */
  width: 100%;
  padding: 1.5rem 0;
  background-image: linear-gradient(
    179deg,
    #e2ecff 0%,
    rgba(255, 255, 255, 0) 19%
  );
  border-radius: 0.25rem;
}

.nav-right {
  margin-left: 1.25rem;
}

.flex-col-center {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 1.5rem;
}

.nav-title {
  font-size: 1.44rem;
  color: #141414;
  font-weight: 700;
}

.nav-more {
  font-size: 0.75rem;
  color: #434343;
  font-weight: 400;
  cursor: pointer;
}

.item {
  display: flex;
  align-items: center;
  height: 3.19rem;
  line-height: 3.19rem;
  box-shadow: inset 0 -0.06rem 0 0 #f0f0f0;
  cursor: pointer;
}

.item img {
  width: 1.06rem;
  margin-right: 0.52rem;
}

.item p {
  font-size: 0.88rem;
  color: #000000;
  letter-spacing: 0.02rem;
  font-weight: 400;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

section {
  margin-top: 1rem;
}
</style>


// WEBPACK FOOTER //
// nav.vue?ab2f6002